// V101-3 (Track 3): the contract every AI-provider collector returns.
// Collectors are pure functions of (options, fetch) → AiCollectorResult; the
// Worker runner records the result. D-CI-4: config + aggregates only — no
// prompt or response content anywhere in a result.
//
// Pure types + catalogue data; no runtime imports.
/**
 * AI-control checks AI-provider collectors may emit. Each kind's manifest
 * `outputs.checks` lists the subset it emits (ADR-0051: emitters on manifests).
 */
export const AI_PROVIDER_CHECKS = [
    { check_key: 'ai_usage_logging_enabled', control_id: 'AL-1', title: 'AI request/usage logging enabled' },
    { check_key: 'ai_log_retention_set', control_id: 'AL-3', title: 'AI log retention configured' },
    { check_key: 'ai_guardrails_configured', control_id: 'LS-4', title: 'Safety guardrails / content filters configured' },
    { check_key: 'ai_prompt_attack_filter', control_id: 'LS-3', title: 'Prompt-injection / jailbreak filtering enabled' },
    { check_key: 'ai_rate_limiting', control_id: 'LS-8', title: 'Rate limiting on AI traffic' },
    { check_key: 'ai_model_inventory', control_id: 'ML-9', title: 'Models and endpoints inventoried in a registry' },
    { check_key: 'ai_model_cards', control_id: 'ML-1', title: 'Model cards / documentation present' },
    { check_key: 'ai_model_monitoring', control_id: 'ML-4', title: 'Model performance/drift monitoring configured' },
    { check_key: 'ai_api_keys_managed', control_id: 'AC-2', title: 'AI API keys scoped, attributable and rotated' },
    { check_key: 'ai_rag_sources_governed', control_id: 'AG-10', title: 'Retrieval (RAG) data sources known and governed' },
    { check_key: 'vector_store_encrypted', control_id: 'DP-11', title: 'Vector store encrypted at rest' },
    { check_key: 'agent_memory_retention', control_id: 'DP-9', title: 'Agent memory has a retention limit' },
    // D-CI-28 (2026-10-06): self-hosted vector DBs / model servers, and AWS AgentCore gateways (V101-3-4), must not answer anonymous calls.
    { check_key: 'ai_service_authn_required', control_id: 'AC-1', title: 'AI service endpoint rejects anonymous calls' },
    // D-CI-33 (2026-10-06): cloud AI threat detection is on and no high/critical AI threat is open (SCC AI Protection).
    { check_key: 'ai_threat_detection_active', control_id: 'IR-2', title: 'AI threat detection on; no high or critical AI threats open' },
];
const BY_KEY = new Map(AI_PROVIDER_CHECKS.map((c) => [c.check_key, c]));
export function aiProviderCheck(checkKey) {
    return BY_KEY.get(checkKey);
}
/** An empty result (a collector that found nothing still returns this shape). */
export function emptyAiResult() {
    return { posture: [], aiChecks: [], rollups: [], inventory: [] };
}
//# sourceMappingURL=ai-collector.js.map